const NATIVE_RESULT_PREFIX = /^Background task result available: [^\n]*(?:\n+|$)/;
const WORKER_RESULT_PREFIX = /^Task result: [^\n]*(?:\n+|$)/;
const HEADING_MARKER = /^#{1,6}\s+/;

/** Removes "Background task result available: <title>" from a native result notice. */
export function stripNativeResultPrefix(text: string): string {
  return text.replace(NATIVE_RESULT_PREFIX, "").trim();
}

/** Removes "Task result: <title>" from a worker result notice. */
export function stripWorkerResultPrefix(text: string): string {
  return text.replace(WORKER_RESULT_PREFIX, "").trim();
}

/** Returns the first non-empty line, stripped of any leading markdown heading marker. */
export function resultDetailLine(text: string): string {
  const line = text.split("\n").map((part) => part.trim()).find(Boolean) ?? "";
  return line.replace(HEADING_MARKER, "");
}
